import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { toast } from "react-toastify";

export default function Step7Confirm({ profileName, businessName, professionals, services, saveComplete, activate, activating }) {
  const handleActivate = async () => {
    const ok = await saveComplete();
    if (!ok) return;
    const activated = await activate();
    if (activated) {
      toast.success("Configuración activada. Redirigiendo...");
      window.location.href = "/";
    }
  };

  return (
    <>
      <Typography variant="h6" gutterBottom>Resumen</Typography>
      <Typography variant="body2">Perfil: <strong>{profileName}</strong></Typography>
      <Typography variant="body2">Negocio: <strong>{businessName}</strong></Typography>
      <Typography variant="body2">Profesionales: {professionals.filter((p) => p.name?.trim()).length}</Typography>
      <Typography variant="body2">Servicios: {services.filter((s) => s.serviceName?.trim()).length}</Typography>
      <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>Al activar se guardará la configuración y se crearán las columnas Kanban para tu perfil.</Typography>
      <Button variant="contained" color="primary" onClick={handleActivate} disabled={activating} style={{ marginTop: 16 }}>
        {activating ? "Activando..." : "Activar"}
      </Button>
    </>
  );
}
